import ProductsMapFrame from './productsmapFrame.jsx';

const frameComponentsMap = {
    productsmap: ProductsMapFrame,
    productsmapsingle: ProductsMapFrame
}

export default frameComponentsMap;
